import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

export interface NavMobileMenuLinkConfig {
  routerLink: string;
  label: string;
  iconPath: string;
  exact?: boolean;
}

@Component({
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  selector: 'lib-nav-mobile-menu-link',
  template: `
    <a
      [routerLink]="config().routerLink"
      routerLinkActive="bg-gray-700 text-orange-400 border-l-4 border-orange-400"
      [routerLinkActiveOptions]="{ exact: config().exact || false }"
      (click)="onClick()"
      class="group border-l-4 border-transparent block pl-3 pr-4 py-3 text-base font-medium text-gray-300 hover:text-orange-400 hover:bg-gray-700 hover:border-orange-400 transition-all duration-200 active:bg-gray-600"
    >
      <div class="flex items-center">
        <svg
          class="w-5 h-5 mr-3 text-gray-400 group-hover:text-orange-400 transition-colors duration-200"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            [attr.d]="config().iconPath"
          ></path>
        </svg>
        {{ config().label }}
      </div>
    </a>
  `,
})
export class NavMobileMenuLinkComponent {
  config = input.required<NavMobileMenuLinkConfig>();
  clicked = output<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
